export default {
    transform(valueKey, labelKey, expandableOptions) {
        return (data) =>
            JSON.parse(data).map((option) => ({
                value: option[valueKey],
                label: option[labelKey],
                heading: option[labelKey],
                options: option[expandableOptions].map((expandableOption) => ({
                    value: expandableOption[valueKey],
                    label: expandableOption[labelKey],
                    data: {
                        optionId: option[valueKey],
                        ...expandableOption,
                    },
                })),
            }))
    },
}
